<template>
    <div>
        <Breadcrumbs main="Orders" title="Order List"/>
        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <div class="row">

              <div class="col-md-12">
                <div class="card">
                    <div hidden class="card-header">
                      <h5>Zero Configuration</h5>
                      <span>DataTables has most features enabled by default, so all you need to do to use it with your own tables is to call the construction function:<code>$().DataTable();</code>.</span><span>Searching, ordering and paging goodness will be immediately added to the table, as shown in this example.</span>
                    </div>

                    <div class="card-body">
                      <b-row>
                          <b-col md="4">

                              <b-input-group label-cols="" class="datatable-">
                                  <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                  <b-input-group-append>
                                      <b-button id="default-secondary" variant="secondary" :disabled="!filter" @click="filter = ''">Clear</b-button>
                                  </b-input-group-append>
                              </b-input-group>

                          </b-col>

                          <!-- <b-col md="3">
                            <b-form-group hidden label-cols="4" content-cols="6"  label="Selection" class="mb-0 datatable-select">
                                <b-form-select
                                  id="table-select-mode-select"
                                  v-model="selectMode"
                                  :options="modes"
                                  class="mb-3"
                                ></b-form-select>
                              </b-form-group>
                          </b-col> -->

                          <b-col md="4">
                              <b-form-group label-cols="4" content-cols="4" label="Per page" class="mb-0 datatable-select">
                                  <b-form-select style="width:100px" v-model="perPage" :options="pageOptions"></b-form-select>
                              </b-form-group>
                              
                          </b-col>

                          <b-col md="4">
                            <div class="text-right">
                              <div class="form-group mb-0 mr-0"></div>
                              <!-- <a  class="btn btn-outline-primary mb-2 mr-3 " v-b-modal.smsModal >
                                <i class="icon-message"> </i> SMS </a
                              >
                              <a class="btn btn-primary mr-3 mb-2" v-b-modal.groupModal >
                                
                                <i class="icon-shopping-car"> </i> Groups</a
                              > -->
                              <!-- <a hidden class="btn btn-outline-primary mr-3 mb-2" v-b-modal.request >
                                
                                <i class="icon-user"> </i> Patient Request</a
                              >
                              <a  class="btn btn-outline-primary mr-3 " v-b-modal.importPatient >
                                <i class="icon-cloud-up"> </i> Import </a
                              > -->
                              <!-- <a  class="btn btn-outline-primary mr-2 mb-2" v-b-modal.addGroupModal v-if="selected.length > 0">
                               Group ({{ selected.length }}) </a
                              >
                              <a v-if="selected.length > 0" @click="clearSelected()" class="btn btn-danger mb-2"><i class="icon-close"> </i> </a
                              > -->
                              <!-- <b-form-group  label-cols="4" content-cols="4" :label="`Apply to (${selected.length})`" class="mb-0 datatable-select">
                                  <b-form-select @input="applyTo" style="width:100px" v-model="select" :options="selectOptions"></b-form-select>
                              </b-form-group> -->
                            </div>

                          </b-col>
                      </b-row>

                      
                      <b-modal id="viewOrdersDetail" ref="viewOrdersDetail" :title="`View Order Details : ${viewOrderDetails ? viewOrderDetails.orderNo : ''}`" ok-title="Ok" class="theme-modal">
                              <b-table stacked :fields="orderdetailsfields" :items="[viewOrderDetails]">

                                <template #cell(scheduled)="row">
                                  <span v-if="row.item.scheduled" class="btn-primary btn btn-xs btn-pill">Scheduled</span><br>
                                      {{ row.item.scheduled ? new Date(row.item.scheduled).toGMTString() : null }}
                                </template>

                                <template #cell(paymentType)="row">
                                  
                                      {{ row.item.paymentType ? row.item.paymentType : '' }}

                                      <span  :class="row.item.payment && row.item.payment.status == 'success' ? 'btn-success btn btn-xs btn-pill' : !row.item.payment ? 'btn-warning btn btn-xs btn-pill' : 'btn-danger btn btn-xs btn-pill'"> {{ row.item.payment && row.item.payment.status == 'success' ? 'Paid' : !row.item.payment ? 'Pending' : 'Failed' }} </span>
                                </template>
                                
                                <template #cell(shop)="row">
                                  <a v-b-tooltip.hover :title="`Call ${row.item.shop}`" style="font-weight:500"  class="txt-primary" :href="`tel:${row.item.shopPhone ? row.item.shopPhone.countryCode+row.item.shopPhone.tel : ''}`">
                                    {{ row.item.shop }}
                                  </a><br>
                                  {{ row.item.shopLocation }}
                                </template>

                                <template #cell(status)="row">
                                  <span :class=" (row.item.orderDelivered !== null ? 'btn-success btn btn-xs btn-pill' : row.item.cancelled ? 'btn-danger btn btn-xs btn-pill' : row.item.confirmed == null ? 'btn-warning btn btn-xs btn-pill' : ( row.item.courierAssigned || row.item.courierDelivering ? 'btn-info btn btn-xs btn-pill' : 'btn-light btn btn-xs btn-pill'))">{{ row.item.status }}</span>
                                </template>

                                <template #cell(userName)="row">
                                  <a v-b-tooltip.hover :title="`Call ${row.item.userName}`" style="font-weight:500" :href="`tel:${row.item.user.countryCode+row.item.user.tel}`" class="txt-primary">
                                    {{ row.item.userName }}
                                  </a>
                                </template>

                                <template #cell(orderNo)="row">
                                    <b v-b-tooltip.hover class="txt-dark" :title="row.item.orderNo"> {{ row.item.orderNo.split("-")[0] }} </b>
                                    <!-- <p> {{ row.item.body }} </p> -->
                                </template>

                                <!-- <template #cell(totalActualPrice)="row">
                                  <div  style="font-weight:500"  class="txt-" >
                                    {{ row.item.totalActualPrice.toFixed(2) }}
                                  </div>
                                </template> -->

                                <template #cell(items)="row">
                                  <p v-for="pro in row.item.items" :key="pro.id">{{ pro.unit+' x '+pro.product+' x '+(pro.discount > 0 ? ((100-pro.discount) * pro.price/100).toFixed(2)+' - ('+pro.discount+'%) off' : pro.price.toFixed(2))+' = '+row.item.country.currency+' '+pro.total }}</p>
                                </template>

                                <template #cell(totalPrice)="row">
                                  <div  style="font-weight:500"  class="txt-primary" >
                                    {{ row.item.country.currency }} {{ row.item.totalPrice.toFixed(2) }}
                                  </div>
                                </template>

                                <template #cell(deliveryFee)="row">
                                    <div  style="font-weight:500"  class="txt-primary" >
                                      {{ row.item.country.currency }} {{ row.item.deliveryFee == 0 ? 'FREE' : row.item.deliveryFee.toFixed(2) }}
                                  </div>
                                </template>
                                
                                <template #cell(total)="row">
                                  <div  style="font-weight:500"  class="txt-" >
                                    {{ row.item.country.currency }} {{ row.item.total.toFixed(2) }}
                                  </div>
                                </template>

                                <template #cell(courier)="row">
                                  <div  style="font-weight:500"  class="txt-primary" >
                                    {{ row.item.courier }}
                                  </div>
                                </template>

                                <template #cell(deliveryName)="row">
                                  <div  style="font-weight:500"  class="txt-primary" >
                                    {{ row.item.courier }}
                                  </div>
                                </template>

                                <template #cell(confirmed)="row">
                                      {{ row.item.confirmed ? new Date(row.item.confirmed).toGMTString() : '' }}
                                </template>

                                <template #cell(courierAssigned)="row">
                                      {{ row.item.courierAssigned ? new Date(row.item.courierAssigned).toGMTString() : '' }}
                                </template>

                                <template #cell(courierDelivering)="row">
                                      {{ row.item.courierDelivering ? new Date(row.item.courierDelivering).toGMTString() : '' }}
                                </template>

                                <template #cell(orderDelivered)="row">
                                      {{ row.item.orderDelivered ? new Date(row.item.orderDelivered).toGMTString() : '' }}
                                </template>

                                <template #cell(createdAt)="row">
                                      {{ new Date(row.item.createdAt).toGMTString() }}
                                </template>
                              </b-table>
                            </b-modal>

                      <b-modal id="groupModal" size="md" ref="groupModal" title="Add Groups" ok-title="Done" class="theme-modal">
                                <template #modal-header>
                                    <h5>{{ editGroup ? 'Edit Groups : '+editGroup : 'Add Groups' }} </h5>
                                    
                                </template>

                                <form id="groupForm" @submit.stop.prevent="submitGroup" class="p-2 px-3">

                                  <div class="form-group ">
                                    <label class="col-form-label" type="text" for="recipient-name">Group name:</label>
                                    <b-form-input v-model="group.group" placeholder="Group"></b-form-input>
                                  </div>
                                  <div class="form-group mt-2">  
                                    <label class="col-form-label" for="">Description</label>
                                    <b-form-textarea
                                        id="textarea"
                                        v-model="group.description"
                                        placeholder="Enter Description..."
                                        rows="3"
                                        max-rows="6"
                                    ></b-form-textarea>
                                  </div>
                                    <b-button block  type="submit" variant="primary">Submit</b-button>

                                </form>
                                <div class="px-3 py-2">
                                    <b-table
                                        show-empty
                                        ref="groupTable"
                                        :items="allGroups"
                                        :fields="groupfields"
                                        :sort-by.sync="sortGroupBy"
                                        :current-page="currentGroupPage"
                                        :per-page="perGroupPage"
                                    >
                                        <template #cell(group)="row">
                                            <span @click="view(row.item)" style="font-weight:500;" class="txt-primary">
                                              {{ row.item.group }} 
                                            </span>
                                            <br>
                                            <span v-b-tooltip.hover title="Description" > {{ row.item.description }} </span>
                                            <i style="font-size:0.8rem" v-if="userAdmin"><br> - {{ row.item.shop }}  </i>
                                        </template>

                                        <template #cell(createdAt)="row">
                                              {{ row.item.createdAt ? new Date(row.item.createdAt).toDateString().substr(4) : '' }}
                                        </template>
                                        

                                        <template #cell(action)="row">

                                        <b-button variant="primary" @click="editgroup(row.item)" class="px-3 mr-2" size="sm"> <i class="icon-pencil"> </i>  </b-button>
                                        <b-button variant="danger" @click="delgroup(row.item)" class="px-3" size="sm"> <i class="icon-trash"> </i> </b-button>

                                        </template>
                                    </b-table>
                                    <p class="px-3">{{ allGroups.length }} items </p>

                                    <b-col md="6" class="my-1">
                                        <b-pagination
                                        v-model="currentGroupPage"
                                        :total-rows="totalGroupRows"
                                        :per-page="perGroupPage"
                                        class="my-0"
                                        ></b-pagination>
                                    </b-col>
                                </div>
                            </b-modal>

                      <div class="table-responsive datatable-vue">
                        <b-table
                          show-empty
                          ref="selectableTable"
                          :items="items"
                          :fields="tablefields"
                          :select-mode="selectMode"
                          :sort-by.sync="sortBy"
                          :sort-desc.sync="sortDesc"
                          :filter="filter"
                          :current-page="currentPage"
                          :per-page="perPage"
                          @filtered="onFiltered"
                          @row-selected="onRowSelected"
                        >
                          <template #cell(actionx)="row">
                            <!-- <b-button size="sm" @click="row.toggleDetails" class="mr-2 ">
                              {{ row.detailsShowing ? 'Hide' : 'Show'}} Details
                            </b-button> -->
                            <b-dropdown text="more" size="sm" left class="mx-2" menu-class="dropdown-content" variant="primary">
                              <b-dropdown-item @click="shops(row.item)">Shop Profiles</b-dropdown-item>
                              <b-dropdown-item @click="alert(row.item)">Alert</b-dropdown-item>
                              <b-dropdown-item @click="Sms(row.item)">SMS</b-dropdown-item>
                              <b-dropdown-item @click="clear(row.item)">Clear Groups</b-dropdown-item>
                              <!-- <b-dropdown-item @click="view(row.item)">View </b-dropdown-item> -->
                              <!-- <b-dropdown-item v-if="row.item.access[0].status" @click="addcomment(row.item)">Add comment</b-dropdown-item> -->
                              <!-- <b-dropdown-item v-if="row.item.access[0].status" @click="viewcomment(row.item.fullname, row.item.tel)">View comment</b-dropdown-item> -->
                              <!-- <b-dropdown-divider></b-dropdown-divider> -->
                              <!-- <b-dropdown-item @click="del(row.index)">Delete </b-dropdown-item> -->
                          </b-dropdown>
                          </template>

                                <template #cell(vendor)="row">
                                  <a v-b-tooltip.hover :title="`Call ${row.item.vendor}`" style="font-weight:500"  class="txt-primary" :href="`tel:${row.item.vendorPhone ? row.item.vendorPhone.countryCode+row.item.vendorPhone.tel : ''}`">
                                    {{ row.item.vendor }}
                                  </a>
                                </template>

                                <template #cell(status)="row">
                                  <div :class=" (row.item.orderDelivered !== null ? 'btn-success btn btn-xs btn-pill' : row.item.cancelled ? 'btn-danger btn btn-xs btn-pill' : row.item.confirmed == null ? 'btn-warning btn btn-xs btn-pill' : ( row.item.courierAssigned || row.item.courierDelivering ? 'btn-info btn btn-xs btn-pill' : 'btn-light btn btn-xs btn-pill'))">{{ row.item.status }}</div>
                                </template>

                                <template #cell(userName)="row">
                                  <a v-b-tooltip.hover :title="`Call ${row.item.userName}`" style="font-weight:500" :href="`tel:${row.item.user.countryCode+row.item.user.tel}`" class="txt-primary">
                                    {{ row.item.userName }}
                                  </a>
                                </template>

                                <template #cell(orderNo)="row">
                                    <b @click="vieworder(row.item)" v-b-tooltip.hover  :title="row.item.orderNo" class="txt-primary">
                                      {{ row.item.orderNo.split("-")[0] }}
                                  </b>
                                    <!-- <p> {{ row.item.body }} </p> -->
                                </template>

                                <template #cell(totalPrice)="row">
                                  <div  style="font-weight:500"  class="txt-primary" >
                                    {{ row.item.country.currency+' '+(row.item.totalPrice+row.item.deliveryFee).toFixed(2) }}
                                  </div>
                                </template>

                                <template #cell(deliveryFee)="row">
                                  <div  style="font-weight:500"  class="txt-primary" >
                                    {{ row.item.country.currency+' '+row.item.deliveryFee == 0 ? 'FREE' : row.item.deliveryFee.toFixed(2) }}
                                  </div>
                                </template>

                                <template #cell(total)="row">
                                  <div  style="font-weight:500"  class="txt-" >
                                    {{ row.item.country.currency+' '+row.item.total.toFixed(2) }}
                                  </div>
                                </template>

                                <template #cell(createdAt)="row">
                                      {{ new Date(row.item.createdAt).toGMTString() }}
                                </template>

                                <template #cell(action)="row">

                                  <b-button variant="primary" @click="vieworder(row.item)" class="px-3 mr-2" size="sm"> <i class="icon-eye"> </i>  </b-button>
                                  <!-- <b-button variant="primary" @click="editcomment(row.item)" class="px-3 mr-2" size="sm"> <i class="icon-pencil"> </i>  </b-button> -->
                                  <b-button v-if="row.item.status == 'pending'" variant="danger" @click="del(row.item)" class="px-3" size="sm"> <i class="icon-trash"> </i> </b-button>

                                </template>
                        </b-table>
                        
                      </div>

                      <p>{{ items.length }} items </p>

                      <b-col md="6" class="my-1">
                        <b-pagination
                          v-model="currentPage"
                          :total-rows="totalRows"
                          :per-page="perPage"
                          class="my-0"
                        ></b-pagination>
                      </b-col>
                      


                    </div>

                </div>
              </div>

            </div>
        </div>
        <!-- Container-fluid Ends-->
    </div>
</template>

<script>
// import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import axios from 'axios'
// import Multiselect from 'vue-multiselect'
import moment from 'moment'

export default {
  data(){
    return{
      singledropzoneOptions:{
          url:"http://localhost:8080/uploadpatient",
          thumbnailWidth: 150,
          maxFiles:1,
          maxFilesize: 0.7,
          addRemoveLinks: true,
          dictDefaultMessage:"<i class='icon-cloud-up'></i><h6>Drop file here or click to upload.</h6><span>( Selected file is <strong>uploaded</strong> imediately after selection.)</span>"
      },
      viewOrderDetails: null,
      requestLoading: false,
      submitting: false,
      categorySelect: true,
      typeSelect: true,
      codeData: {},
      shopTitle: '',
      editGroup: false,
      group: {
        group: '',
        description: ''
      },
      sms: {
        contacts: [],
        groups: [],
        date: '',
        time: '',
        message: ''
      },
      smsParts: 0,
      smsMsg: 0,
      numbers: 0,
      smsGroupDisabled: false,
      smsContactsDisabled: false,
      statusOptions: [
        //   { value: null, text: 'Select ' },
        { value: true, item: 'Yes' },
        { value: false, item: 'No' }
      ],
      tablefieldsx: [
        { key: 'name', label: 'Customer Name', sortable: true, },
        { key: 'phone', label: 'Contact', sortable: false, },
        { key: 'email', label: 'Email', sortable: true, },
        { key: 'gender', label: 'Gender', sortable: true, },
        // { key: 'groups', label: 'Groups', sortable: true, },
        { key: 'dob', label: 'Date of Birth', sortable: true, },
        // { key: 'locationName', label: 'Location', sortable: true, },
        // { key: 'point', label: 'Points', sortable: true, },
        // { key: 'active', label: 'Status', sortable: true, },
        { key: 'date', label: 'Date', sortable: true, },
        { key: 'action', label: 'Action', sortable: false, },
      ],
      tablefields: [
        { key: 'orderNo', label: 'Order No', sortable: false, },
        { key: 'shop', label: 'Shop', sortable: true, },
        { key: 'userName', label: 'Username', sortable: true, },
        { key: 'status', label: 'Status', sortable: true, },
        // { key: 'type', label: 'Type', sortable: true, },
        { key: 'totalPrice', label: 'Total Price', sortable: true, },
        { key: 'deliveryFee', label: 'Delivery', sortable: false, },
        { key: 'total', label: 'Total', sortable: false, },
        { key: 'createdAt', label: 'Date', sortable: false, },
        { key: 'action', label: 'Action', sortable: false, },
      ],
      orderdetailsfields: [
        { key: 'orderNo', label: 'Order No', sortable: false, },
        { key: 'shop', label: 'Shop', sortable: true, },
        { key: 'userName', label: 'Username', sortable: true, },
        { key: 'items', label: 'Items', sortable: true, },
        // { key: 'totalActualPrice', label: 'Total Actual Price', sortable: true, },
        { key: 'totalPrice', label: 'Total Price', sortable: true, },
        { key: 'deliveryFee', label: 'Delivery', sortable: false, },
        { key: 'total', label: 'Total', sortable: false, },
        { key: 'courier', label: 'Courier', sortable: false, },
        { key: 'confirmed', label: 'Confirmed', sortable: false, },
        { key: 'courierAssigned', label: 'Courier Assigned', sortable: false, },
        { key: 'courierDelivering', label: 'Courier Delivering', sortable: false, },
        { key: 'orderDelivered', label: 'Order Delivered', sortable: false, },
        { key: 'deliveryAddressName', label: 'Delivery Address', sortable: false, },
        { key: 'paymentType', label: 'Payment Type', sortable: false, },
        { key: 'scheduled', label: 'Scheduled', sortable: false, },
        { key: 'status', label: 'Status', sortable: true, },
        { key: 'createdAt', label: 'Date', sortable: false, },
        // { key: 'action', label: 'Action', sortable: false, },
      ],
      shopfields: [
        { key: 'shop', label: 'Shop', sortable: true, },
        { key: 'preferences', label: 'Preferences', sortable: false, },
        { key: 'createdAt', label: 'Date', sortable: false, },
        { key: 'action', label: 'Action', sortable: false, },
      ],
      items: [],
      allShops: [],
      allGroups: [],
      allSms: [],
      modes: ['multi', 'single', 'range'],
      filter: null,
      sortBy: 'createdAt',
      sortDesc: true,
      selectMode: 'multi',
      selected: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15, 25, 50, 100],
      groupfields: [
        { key: 'group', label: 'Group', sortable: true, },
        // { key: 'type', label: 'Type', sortable: true, },
        // { key: 'description', label: 'Description', sortable: false, },
        { key: 'createdAt', label: 'Date', sortable: true, },
        { key: 'action', label: 'Action', sortable: false, },
      ],
      smsfields: [
        // { key: 'sender', label: 'sender', sortable: true, },
        { key: 'groups', label: 'Groups', sortable: true, },
        { key: 'tels', label: 'Contacts', sortable: true, },
        // { key: 'contacts', label: 'Contacts', sortable: true, },
        { key: 'message', label: 'Message', sortable: false, },
        { key: 'details', label: 'Details', sortable: false, },
        { key: 'type', label: 'Type', sortable: true, },
        // { key: 'description', label: 'Description', sortable: false, },
        { key: 'date', label: 'Date', sortable: true, },
        { key: 'action', label: 'Action', sortable: false, },
      ],
      sortGroupBy: 'product',
      currentGroupPage: 1,
      totalGroupRows: 1,
      sortSmsBy: 'date',
      currentSmsPage: 1,
      totalSmsRows: 1,
      perGroupPage: 5,
      perSmsPage: 5,
      totalShopRows: 1,
      perShopPage: 5,
      selectOptions: [
        'Group',
      ],
      select: null,
    }
  },
  components: {
    
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.tablefields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key }
        })
    },
    userAdmin() {
      return localStorage.getItem('type') == "admin" ? true : false
    },
    getUser() {
      return this.$store.getters['authentication/getUser']
    }
  },
  created() {
    // watch and fetch
    this.$watch(
      () => this.$route.$params,
      () => {
        this.fetchData()
      },
      { immediate: true }

    )

  },
  watch: {
    dropFile() {
        if (this.dropFile !== null ){
            this.img = window.URL.createObjectURL(this.dropFile)    
        }

        if (this.dropFile == null) {
            window.URL.revokeObjectURL(this.img)
        }
    },
    productFile() {
        if (this.productFile !== null ){
            this.pro = window.URL.createObjectURL(this.productFile)    
        }

        if (this.productFile == null) {
            window.URL.revokeObjectURL(this.pro)
        }
    },
  },
  mounted() {
    // Set the initial number of items
    // this.totalRows = this.items.length
  },
  methods: {
    fetchData() {

     const url =  '/order/'

      axios.get(url)
        .then(response=>{
          //
          this.items = response.data
          this.totalRows = this.items.length

          for (let index = 0; index < this.items.length; index++) {

                // date
                if (this.items[index].createdAt) {
                  this.items[index].date =  (new Date(this.items[index].createdAt)).toDateString().substring(4)
                  // this.items[index].date = (new Date(this.items[index].createdAt)).toDateString().substring(4)
                
                }

            }
        })
        .catch( e => {
          this.$swal({
            title:"Failed!",
            text:e.response.data,
            type:'error'
          });
        })

       
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    onRowSelected(items) {
      this.selected = items
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows()
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected()
    },
    shops(data) {
        // modal
        this.$refs.shopModal.show()
        //
        this.shopTitle = data.name

        //
        // axios.get('/order/'+data.business).then( response=>{
            let _shop = this.getUser.name

            //
            this.allShops = this.userAdmin ? data.shops : data.shops.filter(shop => shop.shop == _shop)
            this.totalShopRows= this.userAdmin ? data.shops.length : data.shops.filter(shop => shop.shop == _shop).length

        // }).catch(error=>{

        //     console.log(error.response.data)
        // })

    },
    groupCustomers() {
      
      axios.post('/group/customers', { shop: this.getUser.name, group: this.select, customers: this.selected }).then(response=> {

            this.$swal({
          title:"Good job!",
          text: response.data,
          type:'success'
        });

        this.fetchData()
        //
        
      })
      .catch( e => {
        this.$swal({
          title:"Failed!",
          text: e.response.data,
          type:'error'
        });
      })

    },
    submitGroup() {

      let url
      let method

      if (this.editGroup) {
        url = '/group/'+this.editGroup
        method = axios.patch;
      } else {
        url = '/group/'
        method = axios.post;
      }

      method(url, { shop: this.getUser.name, group: this.group.group, description: this.group.description } )
      .then(response=>{
        //
        this.$swal({
          title:"Good job!",
          text: response.data,
          type:'success'
        });

        this.fetchData()
        //
        
        
      })
      .catch( e => {
        this.$swal({
          title:"Failed!",
          text: e.response.data,
          type:'error'
        });
      })

    },
    submitSms() {

      this.submitting = true

      //
      let contacts;
      if (this.sms.groups.length > 0) {
        contacts = this.items.filter(d => d.gp.some(x => this.sms.groups.includes(x)) ).map(c=>{ return { phone: c.phone, name:c.name } })
      } else if (this.sms.contacts.length > 0) {
        contacts = this.sms.contacts.map(c=>{ return { phone: c.value, name: c.label } })
      } else if (this.sms.contacts.length == 0) {
        contacts = this.items.map(c=>{ return { phone: c.phone, name: c.name } })
      }

      if (contacts.length > 0 && this.sms.message !== "") {

        axios.post('/shop/sms/', { shop: this.getUser.name, message: this.sms.message, contacts: contacts, groups:  this.sms.groups, scheduled: (this.sms.date !== '' && this.sms.time !== '' ? this.sms.date+' '+this.sms.time : null) } )
        .then(response=>{
          //
          this.$swal({
            title:"Good job!",
            text: response.data,
            type:'success'
          });

          this.fetchData()
          //
          this.submitting = false
          
        })
        .catch( e => {
          this.$swal({
            title:"Failed!",
            text: e.response.data,
            type:'error'
          });

          this.submitting = false
        })
      } else {
        this.submitting = false
      }
    },
    view(data){
      // modal
      this.$refs.viewvendorModal.show()

      this.viewVendor = data
      //
    },
    Sms(data){
      // modal
      this.$refs.smsModal.show()

      this.sms.contacts = [ { label: data.name, value: data.phone } ]
      this.checkContact()
      this.sms.groups = []
      this.checkGroups()
      //
    },
    checkGroups(){
      if (this.sms.groups.length > 0) {
        this.smsContactsDisabled = true
        const no = this.items.filter(d => d.gp.some(x => this.sms.groups.includes(x)) )
        this.numbers = no.length
      } else {
        this.smsContactsDisabled = false
        this.numbers = 0 
      }
    },
    checkContact(){
      if (this.sms.contacts.length > 0) {
        this.smsGroupDisabled = true
        this.numbers = this.sms.contacts.length
      } else {
        this.smsGroupDisabled = false
        this.numbers = 0
      }
    },
    switchCategory() {
        this.categorySelect = this.categorySelect ? false : true
    },
    switchType() {
        this.typeSelect = this.typeSelect ? false : true
    },
    applyTo() {
        //
        this.$refs.groupModal.show()
    },
    vieworder(data) {
        // modal
        this.$refs.viewOrdersDetail.show()
        //
        this.viewOrderDetails = data

    },
    calculateAge(dob) { 
      //
      let now
      now = moment(new Date())
      const _dob = moment(dob)
      return now.diff(_dob, 'years')
    },
    mesLength() {
      const smslen = 160;
      // const maxlen = 800;
      // const maxparts = 5;

      var strlen = this.sms.message.length;
      // var msg = strlen+'/'+maxlen;

      this.smsParts = Math.ceil(strlen/smslen);
      // var msg2 = parts+'/'+maxparts;
    },
    del(data) {

        this.$swal({
        title: "Delete Order '"+data.orderNo.split("-")[0]+"'?",
        text: "Are you sure, You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.value) {
                //
                axios.delete(`/order/${data.vendor}/${(data.orderNo.split("-")[0]).substring(1)}`)
                .then(response=>{
                    //
                    this.$swal({
                    title:"Good job!",
                    text: response.data,
                    type:'success'
                    });
                    //
                    this.fetchData()
                })
                .catch( e => {
                    this.$swal({
                    title:"Failed!",
                    text: e.response.data,
                    type:'error'
                    });
                })
            }
      })

    },
    selectAllContacts() {
      this.sms.contacts = this.items.map((it)=> {
                                          return { label:it.name, value: it.phone }
                                        })
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
/* #patientForm .form-control {
 font-size: inherit;
} */

.table tr > td {
  color: rgba(43,43,43,.54);
}

.loader-box [class*="loader-"] {
    width: 30px;
    height: 30px;
}
</style>